
import Flickity from 'flickity/dist/flickity.pkgd';
import 'waypoints/lib/jquery.waypoints';
import 'waypoints/lib/shortcuts/sticky';
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUI_Default from '../pswp/pswp_ui';
import 'scrollmonitor';
import Rellax from 'rellax';
import CountUp from 'countup.js';
import animsition from 'animsition';
import 'juxtaposejs/build/js/juxtapose.min';
import 'modaal/dist/js/modaal';
import Cookies from 'js-cookie';
import 'jquery-datetimepicker/build/jquery.datetimepicker.full';
import moment from 'moment';
$.datetimepicker.setLocale('en');

export default {
  bookingModal() {
      // $(document.body).on('click', '.button-find-address', function(e){
      //   e.preventDefault()
      //   $('.hidden-postcode').removeClass('hidden-postcode')
      // })
      if ( typeof bookingapp === 'undefined' || bookingapp === null ) {
        return;
      }
      const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
      const validateForm = (form) => {
        $(form).find('#email').parent().parent().find('.error').remove()
        $(form).find('#postcode').parent().parent().find('.error').remove()
        $(form).find('#telephone').parent().parent().find('.error').remove()
        $(form).find('#name').parent().parent().find('.error').remove()
        $(form).find('#address').parent().parent().find('.error').remove()
        $(form).find('#city').parent().parent().find('.error').remove()

        $(form).find('.calendar-container').parent().find('.error').remove()

        let errors = false

        if(!$(form).find('#name').val()){
          $(form).find('#name').parent().parent().append('<div class="error">Your name is required</div')
          errors = true
        }
        if(!$(form).find('#telephone').val()){
          $(form).find('#telephone').parent().parent().append('<div class="error">Your telephone is required</div')
          errors = true
        }
        if(!$(form).find('#postcode').val()){
          $(form).find('#postcode').parent().parent().append('<div class="error">Your postcode is required</div')
          errors = true
        }
        if(!$(form).find('#address').val()){
          $(form).find('#address').parent().parent().append('<div class="error">Your address is required</div')
          errors = true
        }
        if(!$(form).find('#city').val()){
          $(form).find('#city').parent().parent().append('<div class="error">Your town or city is required</div')
          errors = true
        }
        if(!$(form).find('#email').val() || !validateEmail($(form).find('#email').val())){
          $(form).find('#email').parent().parent().append('<div class="error">Your email is required</div')
          errors = true
        }
        if(!$(form).find('.datetimepicker').val() || !$(form).find('.timepicker').val()){
          $(form).find('.calendar-container').parent().append('<div class="error text-center">Please select a date and a time</div')
          errors = true
        }
        return errors
      }
      const validateFormSend = (form) => {
        $(form).find('#email').parent().parent().find('.error').remove()
        $(form).find('#postcode').parent().parent().find('.error').remove()
        $(form).find('#telephone').parent().parent().find('.error').remove()
        $(form).find('#name').parent().parent().find('.error').remove()
        $(form).find('#address').parent().parent().find('.error').remove()
        $(form).find('#city').parent().parent().find('.error').remove()


        let errors = false

        if(!$(form).find('#name').val()){
          $(form).find('#name').parent().parent().append('<div class="error">Your name is required</div')
          errors = true
        }
        if(!$(form).find('#telephone').val()){
          $(form).find('#telephone').parent().parent().append('<div class="error">Your telephone is required</div')
          errors = true
        }
        if(!$(form).find('#postcode').val()){
          $(form).find('#postcode').parent().parent().append('<div class="error">Your postcode is required</div')
          errors = true
        }
        if(!$(form).find('#address').val()){
          $(form).find('#address').parent().parent().append('<div class="error">Your address is required</div')
          errors = true
        }
        if(!$(form).find('#city').val()){
          $(form).find('#city').parent().parent().append('<div class="error">Your town or city is required</div')
          errors = true
        }
        if(!$(form).find('#email').val() || !validateEmail($(form).find('#email').val())){
          $(form).find('#email').parent().parent().append('<div class="error">Your email is required</div')
          errors = true
        }

        return errors
      }

      $(document.body).on('submit', '.booking-form-send', function(e){
        e.preventDefault()
        const form = this
        $(form).find('button.submit').parent().find('.error').remove()
        const errors = validateFormSend(this)
        if(!errors){

           $('.loading-overlay').removeClass('hidden-overlay');
           $.ajax( {
              type: 'POST',
              url:'/wp-json/tw/v1/send-form',
              data: $(this).serialize(),
            } ).done( function( data, status, xhr ) {
              $('.loading-overlay').addClass('hidden-overlay');
              if(data.success){
                window.location.href = "/form-booking-thanks/?showroomname=" + data.data.showroom_name;
              } else {
                $(form).find('button.submit').parent().append('<div class="error text-center">Sorry, there is been an error submitting this request. Please try again later or contact us</div>')
              }
            } ).fail( function( xhr, status, error ) {
                $('.loading-overlay').addClass('hidden-overlay');
                $(form).find('button.submit').parent().append('<div class="error text-center">Sorry, there is been an error submitting this request. Please try again later or contact us</div>')
            } );
        }
      });

      $(document.body).on('submit', '.booking-form', function(e){
        e.preventDefault()
        const form = this
        $(form).find('button.submit').parent().find('.error').remove()
        const errors = validateForm(this)
        if(!errors){

           $('.loading-overlay').removeClass('hidden-overlay');
           $.ajax( {
              type: 'POST',
              url:'/wp-json/tw/v1/booking-place',
              data: $(this).serialize(),
            } ).done( function( data, status, xhr ) {
              $('.loading-overlay').addClass('hidden-overlay');
              if(data.success){
                window.location.href = "/booking-thanks/?showroomname=" + data.data.showroom_name;
              } else {
                $(form).find('button.submit').parent().append('<div class="error text-center">Sorry, there is been an error submitting this request. Please try again later or contact us</div>')
              }
            } ).fail( function( xhr, status, error ) {
                $('.loading-overlay').addClass('hidden-overlay');
                $(form).find('button.submit').parent().append('<div class="error text-center">Sorry, there is been an error submitting this request. Please try again later or contact us</div>')
            } );
        }
      });

      const selectedDay = (ct,$i, elem) => {
          const date = moment(ct).format('DD-MM-YYYY')
          $(elem).find('.calendar-container').parent().find('.error').remove()
          $('.loading-overlay').removeClass('hidden-overlay');
          $.get( `/wp-json/tw/v1/get-available-times?date=${date}&id=${bookingapp.showroom}`, function( data ) {
            $('.loading-overlay').addClass('hidden-overlay');
            if(data.length){
              $(elem).find('.timepicker').datetimepicker('setOptions', {allowTimes: data, timepicker: true })
            } else {
              $(elem).find('.calendar-container').parent().append('<div class="error text-center">Sorry, there are no times available on this date</div')
              $(elem).find('.timepicker').datetimepicker('setOptions', {allowTimes: [], timepicker: false })
            }
          })
      }

      const disabled = []
      if(bookingapp.settings && bookingapp.settings.opening_times && !bookingapp.settings.opening_times.monday.opened){
        disabled.push(1)
      }
      if(bookingapp.settings && bookingapp.settings.opening_times && !bookingapp.settings.opening_times.tuesday.opened){
        disabled.push(2)
      }
      if(bookingapp.settings && bookingapp.settings.opening_times && !bookingapp.settings.opening_times.wednesday.opened){
        disabled.push(3)
      }
      if(bookingapp.settings && bookingapp.settings.opening_times && !bookingapp.settings.opening_times.thursday.opened){
        disabled.push(4)
      }
      if(bookingapp.settings && bookingapp.settings.opening_times && !bookingapp.settings.opening_times.friday.opened){
        disabled.push(5)
      }
      if(bookingapp.settings && bookingapp.settings.opening_times && !bookingapp.settings.opening_times.saturday.opened){
        disabled.push(6)
      }
      if(bookingapp.settings && bookingapp.settings.opening_times && !bookingapp.settings.opening_times.sunday.opened){
        disabled.push(0)
      }

      $('.modal-booking').modaal({
        custom_class: 'booking-elem',
        after_open: function(elem) {
          $(elem).find('.datetimepicker').datetimepicker({
            inline: true,
            todayButton: false,
            timepicker: false,
            dayOfWeekStart: 1,
            format:'d-m-Y',
            defaultSelect: false,
            scrollMonth: false,
            scrollInput: false,
            yearStart: moment().format('YYYY'),
            yearEnd: moment().format('YYYY'),
            minDate: moment().add(1,'days').toDate(),
            maxDate: moment().add(4,'months').toDate(),
            disabledWeekDays: disabled,
            onSelectDate: function(ct,$i) {
              selectedDay(ct,$i, elem)
              $(elem).find('.timepicker').val('')
              $(elem).find('.timepicker').datetimepicker('reset')
            },
          })
          $(elem).find('.timepicker').datetimepicker({
              inline: true,
              datepicker: false,
              format:'H:i',
              timepicker: false,
              defaultSelect: false,
          });
        },
        before_close: function(elem){
          $(elem).find('.datetimepicker').datetimepicker('destroy')
          $(elem).find('.timepicker').datetimepicker('destroy')
        }
      })
      $('.form-booking').modaal({
        custom_class: 'booking-elem'
      })
  },

  normaliseYouTubeLinks($scope) {
      const scope = $scope || $(document);
      scope.find('.js-video-modal').each(function (i) {
        const $link = $(this);
        const href = $link.attr('href') || '';
        let videoId = null;
        const watchMatch = href.match(/[?&]v=([^&#]+)/);
        const shortMatch = href.match(/youtu\.be\/([^?&#]+)/);
        if (watchMatch) {
          videoId = watchMatch[1];
        } else if (shortMatch) {
          videoId = shortMatch[1];
        }
        if (!videoId) return;

        const modalId = 'js-video-modal-inline-' + i + '-' + videoId;
        if (!$('#' + modalId).length) {
          $('body').append(
            '<div id="' + modalId + '" style="display:none;">' +
              '<div class="embed-container">' +
                '<iframe data-src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0" ' +
                  'frameborder="0" allowfullscreen ' +
                  'allow="autoplay; encrypted-media; picture-in-picture">' +
                '</iframe>' +
              '</div>' +
            '</div>'
          );
        }
        $link.attr('href', '#' + modalId);
      });
  },

  modaalsLoad() {

      this.normaliseYouTubeLinks();

      $('.js-video-modal').modaal({
        custom_class: 'video-modal-elem virtualtour-elem',
        after_open: function () {
          const $iframe = $('.modaal-content-container').find('iframe[data-src]');
          $iframe.attr('src', $iframe.data('src'));
        },
        after_close: function () {
          $('[id^="js-video-modal-inline-"], [id^="vb-modal-"] , #virtual-tour').find('iframe').removeAttr('src');
        },
      });

      $('.parking-info').modaal({
        custom_class: 'parking-info-elem',
      });

      $('.virtual-tour').modaal({
        custom_class: 'virtualtour-elem',
        after_open: function () {
          const $iframe = $('.modaal-content-container').find('iframe[data-src]');
          $iframe.attr('src', $iframe.data('src'));
        },
        after_close: function () {
          $('#virtual-tour iframe').removeAttr('src');
        },
      });
      const isCookied = Cookies.get('wintersale') !== '1' ? true : false;
      $('.modal-wintersale').modaal({
        // after_open: function(){
        //   $('.modaal-close').appendTo('.modaal-content');
        // },
        after_close: function() {
          Cookies.set('wintersale', '1', {expires: 0.3});
        },
        start_open: isCookied,
      })
      $(document.body).on('click','.modal-wintersale-link', function(e){
        e.preventDefault()
        $('.modal-wintersale').modaal('close')
      })


  },
  init() {
    this.bookingModal();
    this.modaalsLoad();

    var ieVersion = (function () { if (new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) !== null) { return parseFloat(RegExp.$1); } else { return false; } })();
    var isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
    var isFirefox = typeof InstallTrigger !== 'undefined';


    if(!ieVersion || ieVersion !== 9){
      var anime = require('animejs');
    }

    if (isFirefox) {
        $('html').addClass('isfirefox');
    }


    if (ieVersion) {
        var ieVersionclass = 'ie' + ieVersion;
        $('html').addClass(ieVersionclass);
        $('html').addClass('iexplorer');
    }
    else if (isIE) {
        $('html').addClass('ie11');
    }

    if ($('html').hasClass('iexplorer')) {
        $('#outdated').show();
    }

    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      $('html').addClass('esafari');
    }


    $('#btnCloseUpdateBrowser').click(function (e) {
        e.preventDefault();
        $('#outdated').hide();
    });



    function getScrollbarWidth() {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

        document.body.appendChild(outer);

        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";

        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);

        var widthWithScroll = inner.offsetWidth;

        // remove divs
        outer.parentNode.removeChild(outer);

        return widthNoScroll - widthWithScroll;
    }


    (function () {
        if ( typeof NodeList.prototype.forEach === "function" ) return false;
        NodeList.prototype.forEach = Array.prototype.forEach;
    })();
    (function (root, factory) {
        if (typeof define === "function" && define.amd) {
            define([], factory(root));
        } else if (typeof exports === "object") {
            module.exports = factory(root);
        } else {
            root.LazyLoad = factory(root);
        }
      }) (typeof global !== "undefined" ? global : this.window || this.global, function (root) {

        "use strict";

        const defaults = {
            src: "data-src",
            srcset: "data-srcset",
            selector: ".lazyload",
        };

        /**
        * Merge two or more objects. Returns a new object.
        * @private
        * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
        * @param {Object}   objects  The objects to merge together
        * @returns {Object}          Merged values of defaults and options
        */
        const extend = function ()  {

            let extended = {};
            let deep = false;
            let i = 0;
            let length = arguments.length;

            /* Check if a deep merge */
            if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]") {
                deep = arguments[0];
                i++;
            }

            /* Merge the object into the extended object */
            let merge = function (obj) {
                for (let prop in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                        /* If deep merge and property is an object, merge properties */
                        if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                            extended[prop] = extend(true, extended[prop], obj[prop]);
                        } else {
                            extended[prop] = obj[prop];
                        }
                    }
                }
            };

            /* Loop through each object and conduct a merge */
            for (; i < length; i++) {
                let obj = arguments[i];
                merge(obj);
            }

            return extended;
        };
        LazyLoad.prototype = {
            init: function() {

                /* Without observers load everything and bail out early. */
                if (!root.IntersectionObserver) {
                    this.loadImages();
                    return;
                }

                let self = this;
                let observerConfig = {
                    root: null,
                    rootMargin: "0px",
                    threshold: [0],
                };

                this.observer = new IntersectionObserver(function(entries) {
                    entries.forEach(entry => {
                        if (entry.intersectionRatio > 0) {
                            self.observer.unobserve(entry.target);
                            let src = entry.target.getAttribute(self.settings.src);
                            let srcset = entry.target.getAttribute(self.settings.srcset);
                            if ("img" === entry.target.tagName.toLowerCase()) {
                                if (src) {
                                    entry.target.src = src;
                                }
                                if (srcset) {
                                    entry.target.srcset = srcset;
                                }
                            } else {
                                entry.target.style.backgroundImage = "url(" + src + ")";
                            }
                        }
                    });
                }, observerConfig);

                this.images.forEach(image => {
                    this.observer.observe(image);
                });
            },

            loadAndDestroy: function () {
                if (!this.settings) { return; }
                this.loadImages();
                this.destroy();
            },

            loadImages: function () {
                if (!this.settings) { return; }
                this.images.forEach(image => {
                    let src = image.getAttribute(this.settings.src);
                    let srcset = image.getAttribute(this.settings.srcset);
                    if ("img" === image.tagName.toLowerCase()) {
                        if (src) {
                            image.src = src;
                        }
                        if (srcset) {
                            image.srcset = srcset;
                        }
                    } else {
                        image.style.backgroundImage = "url(" + src + ")";
                    }
                });
            },

            destroy: function () {
                if (!this.settings) { return; }
                this.observer.disconnect();
                this.settings = null;
            },
        };

        function LazyLoad(images, options) {
            this.settings = extend(defaults, options || {});
            this.images = images || document.querySelectorAll(this.settings.selector);
            this.observer = null;
            this.init();
        }


        root.lazyload = function(images, options) {
            return new LazyLoad(images, options);
        };

        if (window.jQuery) {
            const $ = window.jQuery;
            $.fn.lazyload = function (options) {
                options = options || {};
                options.attribute = options.attribute || "data-src";
                new LazyLoad($.makeArray(this), options);
                return this;
            };
        }

        return LazyLoad;
    });




    const App = {

        animeLoad(){

          $(".animsition").animsition({
            inClass: 'fade-in',
            inDuration: 600,
            loading: true,
            timeout: 500,
            onLoadEvent: true,
            loadingClass: 'animsition-loading',
            loadingInner: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"> <path class="st0" d="M283.8 495.7H181.2s30.1-56.5 20.3-128.9c0 0-29.5 5.8-45.7 18.4-16.3 12.9-53.7-9.2-65.4-7.7 0 0 26.7-14.1 31.9-21.5 5.2-7.1 35.9-11.4 47.9-1.5 11.7 9.8 17.8 1.5 17.8 1.5l-31.9-29.2-22.4 7.1s-28.2 17.8-44.5 9.8-33.5-22.1-43.3-16.3c-9.8 5.8 43.3-34.1 64.2-22.7 20.9 11.4 32.8 15 37.5 11.4l-28.2-27S18.7 291.2 10.7 248c0 0 16.3.6 23.6-4.9 7.1-5.8 43.9.6 57.1 18.4s23.6 14.1 23.6 14.1l-24.3-31.3s-34.1-2.8-35.3-39.9c-1.2-37.1-11.1-61.1-11.1-61.1s23 7.1 30.1 17.2c7.1 10.1 23.6 20 21.5 71.2l26.7 35.6 1.8-8s-19.6-20.6-11.1-41.1c8.6-20.6 5.2-48.5 5.2-48.5s25.5 26.4 25.5 47.6c0 21.5-11.7 43.3-11.7 43.3s1.2 13.5 5.2 19.3c4 5.8 53.1 45.4 72.1 45.4l4-26.4-11.7-5.5s-36.5-3.7-37.5-27.6c-.6-24.3-5.8-42.1-5.8-42.1s24.9 5.8 28.9 11.4c4 5.8 23 24.9 20.9 46.4l8 2.1s1.2-51.9-10.4-70.6l-10.4-8s-55 13.5-66-68.5c0 0 15.7 9.2 25.5 9.8 9.8.6 35.3 26.4 37.5 44.8l9.2 4.9-25.5-59.2s-35.9-9.8-38.7-40.5C134.9 65.7 127.2 50 127.2 50s32.8 7.1 42.7 20c9.8 12.9 17.8 54 17.8 54l17.8 35-.6-22.1s-21.5-36.2-1.8-58.9c19.6-22.7 11.1-37.1 11.1-37.1s28.2 38.4 18.4 63.2c-9.8 24.9-13.8 36.2-13.8 36.2l-4 25.5s14.4 39.9 20.9 68.5c0 0 18.4-17.2 22.1-27 4-9.8-4-26.4-4-26.4s-30.7-19.3-19-44.2c11.7-24.9 13.8-56.2 13.8-56.2s26.1 27 25.5 45.4-5.8 49.7-5.8 49.7l4 15.7s19.6-48.5 19.6-67.5c0 0-25.5-28.5-9.8-61.1 15.7-32.8 16.3-58.3 16.3-58.3s34.1 37.1 34.7 64.2c.6 27-27.6 52.8-27.6 52.8l-8.6 37.8s20.3-39.9 43.3-40.5c23-.6 51-1.5 51-1.5s-13.2 49.7-41.1 51.9c-28.2 2.1-48.5 2.1-48.5 2.1s-8-2.8-12.6 7.1-26.1 48.5-26.1 48.5l13.8-2.1s11.7-27 20.9-28.5 53.1 2.1 64.8-10.7c0 0-12.6 34.1-38.1 47-25.5 12.9-47.9 3.7-47.9 3.7l-17.8 5.8s-14.4 11.4-15 29.2c-.6 17.8 11.1 93.9 11.1 93.9l9.8-2.1.6-12s-14.4-32.8-1.8-50.7c12.3-17.8 29.5-31.3 31.3-43.3 0 0 23.6 57.7-18.4 92.4l-1.8 12s25.5-4.3 41.1-20l1.8-16.3s-18.4-37.1 6.4-60.5c24.9-23.3 24.9-28.5 24.9-28.5s9.8 24.3 3.4 42.7-25.5 46.4-25.5 46.4v11.4s41.1-24.9 47.9-39.3c0 0-15.7-39.9-4.6-63.2s19.6-50.7 19.6-50.7 15 26.4 14.4 45.4c-.6 19.3-19.6 52.8-19.6 52.8v13.5l31.3-39.9s-7.4-47.6 14.4-69.7c21.5-22.1 20.9-38.4 20.9-38.4s16.3 39.9 10.4 56.2c-5.8 16.3-19 39.9-29.5 48.5l-17.8 22.7s25.5-16.3 34.7-16.3 41.1 8.6 41.1 8.6-19.6 23.3-28.9 26.4c-9.2 2.8-35.9 3.7-47.9-7.1l-7.1 1.5s-26.7 31.3-39.3 39.9l11.7 3.7s19-22.1 38.1-21.5c19 .6 28.9 16.3 50.3 12 0 0-17.8 30.7-48.5 32.8-30.7 2.1-43.3-12-43.3-12l-19-4.3s-35.3 23.6-56.2 35.6l15.7 2.1s22.1-21.2 38.1-18.4c15.7 2.8 32.2 21.5 54.3 17.8 0 0-30.7 55.6-91.8 14.1l-34.1-4.9-11.4 9.2c1.1.1 12.8 83.3 13.4 102"/></svg><div class="loading"><svg width="200px" height="200px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling" style="background: none;"> <circle cx="50" cy="50" fill="none" ng-attr-stroke="{{config.color}}" ng-attr-stroke-width="{{config.width}}" ng-attr-r="{{config.radius}}" ng-attr-stroke-dasharray="{{config.dasharray}}" stroke="#efefef" stroke-width="1" r="35" stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(168 50 50)"> <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform> </circle> </svg></div>',
          });

          $('.animsition').on('animsition.inStart', function(){

            App.reveal();
          });
          $('.animsition').on('animsition.inEnd', function(){
            App.parallaxExt();
            App.rellax();
            $('.parallax-mirror').addClass('show');
          });
        },

        postcodeLookup(){
          if(!$('.tab ul.tabs').hasClass('hidden')){
            $('.tab ul.tabs').addClass('active').find('> li:eq(0)').addClass('current');
          }


          $('.tab ul.tabs li a').click(function (g) {
            var tab = $(this).closest('.tab'),
              index = $(this).closest('li').index();

            tab.find('ul.tabs > li').removeClass('current');
            $(this).closest('li').addClass('current');

            tab.find('.tab_content').find('div.tabs_item').not('div.tabs_item:eq(' + index + ')').slideUp();
            tab.find('.tab_content').find('div.tabs_item:eq(' + index + ')').slideDown();

            g.preventDefault();
          });

          $.support.placeholder = (function(){
              var i = document.createElement('input');
              return 'placeholder' in i;
          })();

          if($.support.placeholder) {
              $('.form-label').each(function(){
                  $(this).addClass('js-hide-label');
              });

              // Code for adding/removing classes here
              $('.form-group').find('input, textarea').on('keyup blur focus', function(e){

                  // Cache our selectors
                  var $this = $(this),
                      $parent = $this.parent().parent().find("label");

                  if (e.type == 'keyup') {
                      if( $this.val() == '' ) {
                          $parent.addClass('js-hide-label');
                      } else {
                          $parent.removeClass('js-hide-label');
                      }
                  }
                  else if (e.type == 'blur') {
                      if( $this.val() == '' ) {
                          $parent.addClass('js-hide-label');
                      }
                      else {
                          $parent.removeClass('js-hide-label').addClass('js-unhighlight-label');
                      }
                  }
                  else if (e.type == 'focus') {
                      if( $this.val() !== '' ) {
                          $parent.removeClass('js-unhighlight-label');
                      }
                  }
              });
          }

          $('[data-enablesend]').find('input').removeClass('wpcf7-form-control wpcf7-submit');


          var wpcf7Elm = $( '.wpcf7' );





          function get_location(dest, code) {

            var postcode = format_pcode(code.val());
            var wrap = dest.find('.postcode');

            if (!postcode) {
              if( wrap.find('.wpcf7-not-valid-tip').length > 0 ){
                wrap.find('.wpcf7-not-valid-tip').text('Please enter a Postcode.');
              } else {
                wrap.append('<span role="alert" class="wpcf7-not-valid-tip">Please enter a Postcode.</span>');
              }
              code.focus();
            } else if (!validate_pcode(postcode, wrap)) {
              code.focus();
            } else {

              var httpreq = getHTTPObject();
              var url = $('body').attr('data-app') + "/addresslist.php?postcode=" + postcode;

              if (httpreq) {
                httpreq.open("GET", url, true);
                httpreq.onreadystatechange = function() {
                  if (httpreq.readyState == 4) {
                    dest.find('[data-locations]').find('.locationwrap').html(httpreq.responseText);
                    dest.find('[data-locationshidden]').slideDown();
                    dest.find('[data-enablesend]').slideDown();
                    if (typeof hook_into_postal_address_locations == 'function') {
                      hook_into_postal_address_locations(dest.find('[data-locations]').find('select'), dest);
                    }


                  }
                  return true;
                }
                httpreq.send(null);
              }
            }
          }

        function hook_into_postal_address_locations(args, form) {
              var _select_postal_address = args;


              var address_line_1 = $(form).find('.address-1').find('input'),
                  address_line_2 = $(form).find('.address-2').find('input'),
                  address_line_3 = $(form).find('.address-3').find('input'),
                  town_city_field = $(form).find('.town').find('input'),
                  county_field = $(form).find('.county').find('input'),
                  country_field = $(form).find('.country').find('input');



              _select_postal_address.change(function() {
                  var _current_postal_address = $('option:selected', _select_postal_address);
                  var _current_postal_address_lookup_code = _current_postal_address.val();


                  jQuery.getJSON( $('body').attr('data-app') + '/addresslist_components.php?postkey=' + _current_postal_address_lookup_code, function(json_data) {
                      if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                        $(form).find('.address').find('input').val('')
                        $(form).find('.city').find('input').val('')
                      }
                      address_line_1.val('');
                      address_line_2.val('');
                      address_line_3.val('');
                      town_city_field.val('');
                      county_field.val('');


                      var _address_property_present = 0,
                          _address_company_present = 0,
                          _address_street_present = 0;


                      jQuery.each(json_data, function(key, val) {




                          var property;

                              if (key == 'organisation') {
                                if(val.length){
                                  address_line_1.val(val);

                                  if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                                    $(form).find('.address').find('input').val(val)
                                  }
                                  _address_company_present = 1;
                                }
                              } else if (key == 'property') {
                                if(val.length){
                                  if(_address_company_present){
                                    address_line_1.val(address_line_1.val() + ', '+ val);
                                    if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                                      $(form).find('.address').find('input').val($(form).find('.address').find('input').val() + ', '+ val)
                                    }
                                  } else {
                                    address_line_1.val(val);
                                    if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                                      $(form).find('.address').find('input').val(val)
                                    }
                                  }
                                  _address_property_present = 1;
                                }

                              } else if (key == 'street') {
                                if(val.length){
                                  address_line_2.val(val);
                                  _address_street_present = 1;
                                  if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                                    if($(form).find('.address').find('input').val() !== ''){
                                        $(form).find('.address').find('input').val($(form).find('.address').find('input').val() + ', '+ val)
                                    }
                                    else {
                                      if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                                        $(form).find('.address').find('input').val(val)
                                      }
                                    }
                                  }
                                }
                              } else if (key == 'locality') {
                                if(val.length){
                                  address_line_3.val(val);
                                  if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                                    $(form).find('.city').find('input').val(val)
                                  }
                                }
                              } else if (key == 'town') {
                                if(val.length){
                                  town_city_field.val(val);

                                  if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                                    if($(form).find('.city').find('input').val() !== ''){
                                        $(form).find('.city').find('input').val($(form).find('.city').find('input').val() + ', '+ val)
                                    }
                                    else {
                                      if(form.hasClass('booking-form') || form.hasClass('booking-form-send')){
                                        $(form).find('.city').find('input').val(val)
                                      }
                                    }
                                  }


                                }
                              } else if (key == 'county') {
                                if(val.length){
                                  county_field.val(val);
                                }
                              }


                              country_field.val('United Kingdom');
                      });



                      if(!_address_company_present && !_address_property_present){
                           address_line_1.val(address_line_2.val());
                           address_line_2.val('');
                      }

                      // if (!_address_property_present && _address_street_present) {
                      //     address_line_1.val(address_line_2.val());
                      //     address_line_2.val('');
                      // }

                  });
              });
          }


          function getHTTPObject() {
            if (typeof XMLHttpRequest != 'undefined') {
              return new XMLHttpRequest();
            }
            try {
              return new ActiveXObject("Msxml2.XMLHTTP");
            }
            catch (e) {
              try {
                return new ActiveXObject("Microsoft.XMLHTTP");
              }
              catch (e) {
                console.log('Error');
              }
            }
            return false;
          }




          function format_pcode(txt){ //check postcode format is valid
            var size = txt.length;
            var txt = txt.toUpperCase().replace(/\s/g, ''); //Change to uppercase
            //Strip leading spaces
            while (txt.slice(0,1) == " ") {txt = txt.substr(1,size-1);size = txt.length;}
            //Strip trailing spaces
            while(txt.slice(size-1,size)== " ") {txt = txt.substr(0,size-1);size = txt.length;}
            return txt; //write back to form field
          }


          function validate_pcode(txt, container){ //check postcode format is valid

            var size = txt.length;
            if (!(txt.match(/^[0-9A-Z\s]+$/)))  {   //  -- added by RF --

              if( container.find('.wpcf7-not-valid-tip').length > 0 ){
                container.find('.wpcf7-not-valid-tip').text(txt + " is not a valid postcode - invalid characters");
              } else {
                container.append('<span role="alert" class="wpcf7-not-valid-tip">' + txt + ' is not a valid postcode - invalid characters</span>');
              }


              return false;
            }
             if (size < 5 || size > 8){ //Code length rule

              if( container.find('.wpcf7-not-valid-tip').length > 0 ){
                container.find('.wpcf7-not-valid-tip').text(txt + " is not a valid postcode - wrong length");
              } else {
                container.append('<span role="alert" class="wpcf7-not-valid-tip">' + txt + ' is not a valid postcode - wrong length</span>');
              }


              return false;
              }
             if (!(isNaN(txt.charAt(0)))){ //leftmost character must be alpha character rule


              if( container.find('.wpcf7-not-valid-tip').length > 0 ){
                container.find('.wpcf7-not-valid-tip').text(txt + " is not a valid postcode - cannot start with a number");
              } else {
                container.append('<span role="alert" class="wpcf7-not-valid-tip">' + txt + ' is not a valid postcode - cannot start with a number</span>');
              }


               return false;
              }
             if (isNaN(txt.charAt(size-3))){ //first character of inward code must be numeric rule


              if( container.find('.wpcf7-not-valid-tip').length > 0 ){
                container.find('.wpcf7-not-valid-tip').text(txt + " is not a valid postcode - alpha character in wrong position");
              } else {
                container.append('<span role="alert" class="wpcf7-not-valid-tip">' + txt + ' is not a valid postcode - alpha character in wrong position</span>');
              }


               return false;
              }
             if (!(isNaN(txt.charAt(size-2)))){ //second character of inward code must be alpha rule

              if( container.find('.wpcf7-not-valid-tip').length > 0 ){
                container.find('.wpcf7-not-valid-tip').text(txt + " is not a valid postcode - number in wrong position");
              } else {
                container.append('<span role="alert" class="wpcf7-not-valid-tip">' + txt + ' is not a valid postcode - number in wrong position</span>');
              }




               return false;
              }
             if (!(isNaN(txt.charAt(size-1)))){ //third character of inward code must be alpha rule

              if( container.find('.wpcf7-not-valid-tip').length > 0 ){
                container.find('.wpcf7-not-valid-tip').text(txt + " is not a valid postcode - number in wrong position");
              } else {
                container.append('<span role="alert" class="wpcf7-not-valid-tip">' + txt + ' is not a valid postcode - number in wrong position</span>');
              }

               return false;
              }
             //if (!(txt.charAt(size-4) == " ")){//space in position length-3 rule
             //  alert(txt + " is not a valid postcode - no space or space in wrong position");
             //  return false;
             //  }
             var count1 = txt.indexOf(" "); var count2 = txt.lastIndexOf(" ");
             if (count1 != count2){//only one space rule

              if( container.find('.wpcf7-not-valid-tip').length > 0 ){
                container.find('.wpcf7-not-valid-tip').text(txt + " is not a valid postcode - only one space allowed");
              } else {
                container.append('<span role="alert" class="wpcf7-not-valid-tip">' + txt + ' is not a valid postcode - only one space allowed</span>');
              }

               return false;
              }

          return true;
          }


          $('.button__postcode').click(function(e){
              e.preventDefault();
              get_location( $(this).parentsUntil('.wpcf7'), $(this).parent().parent().find('.postcode').find('input') );
          });



        $(document.body).on('click', '.button__postcode-booking-form',function(e){
              e.preventDefault();
              const form = $(this).closest('.wpcf7');
              get_location( form, form.find('.postcode').find('input') );
          })













        },
        stickyCTA(){



              var stickyShare = $('.content__single_blog').waypoint(function(direction) {
                if(direction === 'down'){
                      $('.share-blog').addClass('is_stuck');
                      $('.share-blog').css('top', $('header.banner').outerHeight());
                } else {
                  $('.share-blog').removeClass('is_stuck');
                  $('.share-blog').css('top', '0px');
                }
              }, {
                offset: $('header.banner').outerHeight(),
              });


              var stickyShareFooter = $('.footer_blog').waypoint(function(direction) {
                if(direction === 'down'){
                      $('.share-blog').addClass('is_at_end');
                      $('.share-blog').css('top', '').css('bottom', '0');
                } else {
                  $('.share-blog').removeClass('is_at_end');
                  $('.share-blog').css('top', $('header.banner').outerHeight()).css('bottom', '');
                }
              }, {
                offset: $('header.banner').outerHeight() + $('.share-blog').outerHeight(),
              });




              var waypoints = $('[data-cta-start]').waypoint(function(direction) {
                if(direction === 'down'){
                  $('.ctas__footer').addClass('showing');
                } else {
                  $('.ctas__footer').removeClass('showing');
                }
              }, {
                  offset: function() {
                    return this.context.innerHeight() - this.adapter.outerHeight()
                  },
                });






              var waypointsno = $('[data-cta-stop]').waypoint(function(direction) {
                if(direction === 'down'){
                  $('.ctas__footer').removeClass('showing');
                } else {
                  $('.ctas__footer').addClass('showing');
                }

              }, {
                  offset: 'bottom-in-view',
              });

              $(window).resize(function(){
                Waypoint.refreshAll();
              });


        },
        countupLoad(){

          var $fadedelements = $('[data-count]');
          $fadedelements.each(function(){
            var el = $(this),
                start = el.attr('data-count-start'),
                finish = el.attr('data-count-end'),
                options = {
                  useEasing: true,
                  useGrouping: false,
                  separator: ',',
                  decimal: '',
                };

            var elementWatcher = scrollMonitor.create(el);
            var numAnim = new CountUp(el[0], start, finish, 0, 4, options);
            elementWatcher.fullyEnterViewport(function() {
              setTimeout(function(){

                if(!el.hasClass('done')){
                  numAnim.start();
                }
                el.addClass('done');
              }, 500);

            });


          });


        },
        parallaxExt(){

          (function() {
            var lastTime = 0;
            var vendors = ['ms', 'moz', 'webkit', 'o'];
            for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
              window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
              window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                || window[vendors[x]+'CancelRequestAnimationFrame'];
            }

            if (!window.requestAnimationFrame)
              window.requestAnimationFrame = function(callback) {
                var currTime = new Date().getTime();
                var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                var id = window.setTimeout(function() { callback(currTime + timeToCall); },
                  timeToCall);
                lastTime = currTime + timeToCall;
                return id;
              };

            if (!window.cancelAnimationFrame)
              window.cancelAnimationFrame = function(id) {
                clearTimeout(id);
              };
          }());


          // Parallax Constructor

          function Parallax(element, options) {
            var self = this;

            if (typeof options == 'object') {
              delete options.refresh;
              delete options.render;
              $.extend(this, options);
            }

            this.$element = $(element);

            if (!this.imageSrc && this.$element.is('img')) {
              this.imageSrc = this.$element.attr('src');
            }

            var positions = (this.position + '').toLowerCase().match(/\S+/g) || [];

            if (positions.length < 1) {
              positions.push('center');
            }
            if (positions.length == 1) {
              positions.push(positions[0]);
            }

            if (positions[0] == 'top' || positions[0] == 'bottom' || positions[1] == 'left' || positions[1] == 'right') {
              positions = [positions[1], positions[0]];
            }

            if (this.positionX != undefined) positions[0] = this.positionX.toLowerCase();
            if (this.positionY != undefined) positions[1] = this.positionY.toLowerCase();

            self.positionX = positions[0];
            self.positionY = positions[1];

            if (this.positionX != 'left' && this.positionX != 'right') {
              if (isNaN(parseInt(this.positionX))) {
                this.positionX = 'center';
              } else {
                this.positionX = parseInt(this.positionX);
              }
            }

            if (this.positionY != 'top' && this.positionY != 'bottom') {
              if (isNaN(parseInt(this.positionY))) {
                this.positionY = 'center';
              } else {
                this.positionY = parseInt(this.positionY);
              }
            }

            this.position =
              this.positionX + (isNaN(this.positionX)? '' : 'px') + ' ' +
              this.positionY + (isNaN(this.positionY)? '' : 'px');

            if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
              if (this.imageSrc && this.iosFix && !this.$element.is('img')) {
                this.$element.css({
                  backgroundImage: 'url(' + this.imageSrc + ')',
                  backgroundSize: 'cover',
                  backgroundPosition: this.position,
                });
              }
              return this;
            }

            if (navigator.userAgent.match(/(Android)/)) {
              if (this.imageSrc && this.androidFix && !this.$element.is('img')) {
                this.$element.css({
                  backgroundImage: 'url(' + this.imageSrc + ')',
                  backgroundSize: 'cover',
                  backgroundPosition: this.position,
                });
              }
              return this;
            }

            this.$mirror = $('<div />').prependTo('.animsition');

            var slider = this.$element.find('>.parallax-slider');
            var sliderExisted = false;

            if (slider.length == 0)
              this.$slider = $('<img />').prependTo(this.$mirror);
            else {
              this.$slider = slider.prependTo(this.$mirror)
              sliderExisted = true;
            }

            this.$mirror.addClass('parallax-mirror').css({
              visibility: 'hidden',
              zIndex: this.zIndex,
              position: 'fixed',
              top: 0,
              left: 0,
              overflow: 'hidden',
            });

            this.$slider.addClass('parallax-slider').one('load', function() {
              if (!self.naturalHeight || !self.naturalWidth) {
                self.naturalHeight = this.naturalHeight || this.height || 1;
                self.naturalWidth  = this.naturalWidth  || this.width  || 1;
              }
              self.aspectRatio = self.naturalWidth / self.naturalHeight;

              Parallax.isSetup || Parallax.setup();
              Parallax.sliders.push(self);
              Parallax.isFresh = false;
              Parallax.requestRender();
            });

            if (!sliderExisted)
              this.$slider[0].src = this.imageSrc;

            if (this.naturalHeight && this.naturalWidth || this.$slider[0].complete || slider.length > 0) {
              this.$slider.trigger('load');
            }

          }


          // Parallax Instance Methods

          $.extend(Parallax.prototype, {
            speed:    0.2,
            bleed:    0,
            zIndex:   -100,
            iosFix:   true,
            androidFix: true,
            position: 'center',
            overScrollFix: false,

            refresh: function() {
              this.boxWidth        = this.$element.outerWidth();
              this.boxHeight       = this.$element.outerHeight() + this.bleed * 2;
              this.boxOffsetTop    = this.$element.offset().top - this.bleed;
              this.boxOffsetLeft   = this.$element.offset().left;
              this.boxOffsetBottom = this.boxOffsetTop + this.boxHeight;

              var winHeight = Parallax.winHeight;
              var docHeight = Parallax.docHeight;
              var maxOffset = Math.min(this.boxOffsetTop, docHeight - winHeight);
              var minOffset = Math.max(this.boxOffsetTop + this.boxHeight - winHeight, 0);
              var imageHeightMin = this.boxHeight + (maxOffset - minOffset) * (1 - this.speed) | 0;
              var imageOffsetMin = (this.boxOffsetTop - maxOffset) * (1 - this.speed) | 0;

              if (imageHeightMin * this.aspectRatio >= this.boxWidth) {
                this.imageWidth    = imageHeightMin * this.aspectRatio | 0;
                this.imageHeight   = imageHeightMin;
                this.offsetBaseTop = imageOffsetMin;

                var margin = this.imageWidth - this.boxWidth;

                if (this.positionX == 'left') {
                  this.offsetLeft = 0;
                } else if (this.positionX == 'right') {
                  this.offsetLeft = - margin;
                } else if (!isNaN(this.positionX)) {
                  this.offsetLeft = Math.max(this.positionX, - margin);
                } else {
                  this.offsetLeft = - margin / 2 | 0;
                }
              } else {
                this.imageWidth    = this.boxWidth;
                this.imageHeight   = this.boxWidth / this.aspectRatio | 0;
                this.offsetLeft    = 0;

                var margin = this.imageHeight - imageHeightMin;

                if (this.positionY == 'top') {
                  this.offsetBaseTop = imageOffsetMin;
                } else if (this.positionY == 'bottom') {
                  this.offsetBaseTop = imageOffsetMin - margin;
                } else if (!isNaN(this.positionY)) {
                  this.offsetBaseTop = imageOffsetMin + Math.max(this.positionY, - margin);
                } else {
                  this.offsetBaseTop = imageOffsetMin - margin / 2 | 0;
                }
              }
            },

            render: function() {
              var scrollTop    = Parallax.scrollTop;
              var scrollLeft   = Parallax.scrollLeft;
              var overScroll   = this.overScrollFix ? Parallax.overScroll : 0;
              var scrollBottom = scrollTop + Parallax.winHeight;

              if (this.boxOffsetBottom > scrollTop && this.boxOffsetTop <= scrollBottom) {
                this.visibility = 'visible';
                this.mirrorTop = this.boxOffsetTop  - scrollTop;
                this.mirrorLeft = this.boxOffsetLeft - scrollLeft;
                this.offsetTop = this.offsetBaseTop - this.mirrorTop * (1 - this.speed);
              } else {
                this.visibility = 'hidden';
              }

              this.$mirror.css({
                transform: 'translate3d(0px, 0px, 0px)',
                visibility: this.visibility,
                top: this.mirrorTop - overScroll,
                left: this.mirrorLeft,
                height: this.boxHeight,
                width: this.boxWidth,
              });

              this.$slider.css({
                transform: 'translate3d(0px, 0px, 0px)',
                position: 'absolute',
                top: this.offsetTop,
                left: this.offsetLeft,
                height: this.imageHeight,
                width: this.imageWidth,
                maxWidth: 'none',
              });
            },
          });


          // Parallax Static Methods

          $.extend(Parallax, {
            scrollTop:    0,
            scrollLeft:   0,
            winHeight:    0,
            winWidth:     0,
            docHeight:    1 << 30,
            docWidth:     1 << 30,
            sliders:      [],
            isReady:      false,
            isFresh:      false,
            isBusy:       false,

            setup: function() {
              if (this.isReady) return;

              var $doc = $(document), $win = $(window);

              var loadDimensions = function() {
                Parallax.winHeight = $win.height();
                Parallax.winWidth  = $win.width();
                Parallax.docHeight = $doc.height();
                Parallax.docWidth  = $doc.width();
              };

              var loadScrollPosition = function() {
                var winScrollTop  = $win.scrollTop();
                var scrollTopMax  = Parallax.docHeight - Parallax.winHeight;
                var scrollLeftMax = Parallax.docWidth  - Parallax.winWidth;
                Parallax.scrollTop  = Math.max(0, Math.min(scrollTopMax,  winScrollTop));
                Parallax.scrollLeft = Math.max(0, Math.min(scrollLeftMax, $win.scrollLeft()));
                Parallax.overScroll = Math.max(winScrollTop - scrollTopMax, Math.min(winScrollTop, 0));
              };

              $win.on('resize.px.parallax load.px.parallax', function() {
                  loadDimensions();
                  Parallax.isFresh = false;
                  Parallax.requestRender();
                })
                .on('scroll.px.parallax load.px.parallax', function() {
                  loadScrollPosition();
                  Parallax.requestRender();
                });

              loadDimensions();
              loadScrollPosition();

              this.isReady = true;
            },

            configure: function(options) {
              if (typeof options == 'object') {
                delete options.refresh;
                delete options.render;
                $.extend(this.prototype, options);
              }
            },

            refresh: function() {
              $.each(this.sliders, function(){ this.refresh() });
              this.isFresh = true;
              jQuery(window).resize();
            },

            render: function() {
              this.isFresh || this.refresh();
              $.each(this.sliders, function(){ this.render() });
            },

            requestRender: function() {
              var self = this;

              if (!this.isBusy) {
                this.isBusy = true;
                window.requestAnimationFrame(function() {
                  self.render();
                  self.isBusy = false;
                });
              }
            },
            destroy: function(el){
              var i,
                  parallaxElement = $(el).data('px.parallax');
              parallaxElement.$mirror.remove();
              for(i=0; i < this.sliders.length; i+=1){
                if(this.sliders[i] == parallaxElement){
                  this.sliders.splice(i, 1);
                }
              }
              $(el).data('px.parallax', false);
              if(this.sliders.length === 0){
                $(window).off('scroll.px.parallax resize.px.parallax load.px.parallax');
                this.isReady = false;
                Parallax.isSetup = false;
              }
            },
          });


          // Parallax Plugin Definition

          function Plugin(option) {
            return this.each(function () {
              var $this = $(this);
              var options = typeof option == 'object' && option;

              if (this == window || this == document || $this.is('.animsition')) {
                Parallax.configure(options);
              }
              else if (!$this.data('px.parallax')) {
                options = $.extend({}, $this.data(), options);
                $this.data('px.parallax', new Parallax(this, options));
              }
              else if (typeof option == 'object')
              {
                $.extend($this.data('px.parallax'), options);
              }
              if (typeof option == 'string') {
                if(option == 'destroy'){
                    Parallax['destroy'](this);
                }else{
                  Parallax[option]();
                }
              }
            })
          }

          var old = $.fn.parallax;

          $.fn.parallax             = Plugin;
          $.fn.parallax.Constructor = Parallax;


          // Parallax No Conflict

          $.fn.parallax.noConflict = function () {
            $.fn.parallax = old;
            return this;
          };


          $(document).on('ready.px.parallax.data-api', function () {
            $('[data-parallax=scroll]').parallax();
          });

          $('.parallax-window').each(function(){
            $(this).parallax({
              naturalWidth: $(this).attr('data-natural-width'),
              naturalHeight: $(this).attr('data-natural-height'),
            });
          });

          $(window).trigger('resize.px.parallax');
          jQuery(document).on( 'scroll', function(){
            jQuery(window).resize();
             jQuery(window).trigger('resize.px.parallax');
          });

          window.addEventListener('resize',function(){
                setTimeout(function() {
                  $(window).trigger('resize.px.parallax');
                }, 375);
          });

        },
        rellax(){
          if($(window).width() > 1000){
           if($('[data-type=parallax]').length){
              var REllax = new Rellax('[data-type=parallax]', {
                center: true,
              });
              $(window).resize(function(){
                if($(window).width() <= 1000){
                  REllax.destroy();
                }
              });
            }

          }

        },

        lazyLoad() {
          let images = document.querySelectorAll(".lzload");
          let lazy = lazyload(images);
        },
        slidersPages(){


          $(document.body).on('click', '[data-scrollto]', function () {
              var anchor = $(this).attr('data-scrollto');
              $('html, body').animate({
                  scrollTop: $(anchor).offset().top -100
              }, 500);

              return false;
          });


          $('.hero-carousel').click(function(e){
            e.preventDefault();





            $('html, body').animate({
                scrollTop: $('[data-point-h]').offset().top - 60,
            }, 500);

          });
          // $('.home-carousel .flickity-viewport').click(function(e){
          //   e.preventDefault();

          //   $('html, body').animate({
          //       scrollTop: $('[data-point-h]').offset().top - 60,
          //   }, 500);

          // });

          var $carousel = $('.hero-carousel').flickity({
            autoPlay: 5500,
            pauseAutoPlayOnHover: false,
            cellAlign: 'center',
            cellSelector: '.hero-carousel__item',
            draggable: false,
            prevNextButtons: false,
            pageDots: false,
            percentPosition: false,
            wrapAround: true,
          });

          if($('.hero-carousel .hero-carousel__item').length > 2){
            App.sliderParallax($carousel);
          }



          var $related = $('.related__posts').flickity({
            cellSelector: '.item-related',
            prevNextButtons: true,
            pageDots: false,
            contain: true,
            groupCells: true,
            arrowShape: 'M75,100L25,50L75,0',
          });


          var $related = $('.magazines').flickity({
            cellSelector: '.issue',
            prevNextButtons: true,
            pageDots: false,
            contain: true,
            groupCells: true,
            arrowShape: 'M75,100L25,50L75,0',
          });


          var $relatedcases = $('.related_cases').flickity({
            cellSelector: '.item-related',
            prevNextButtons: true,
            pageDots: false,
            contain: true,
            groupCells: true,
            arrowShape: 'M75,100L25,50L75,0',
          });

        },
        animateArrowPrev(element){
          var tl = anime.timeline();
          var elem = $(element).find('svg')[0];
          tl
            .add({
              targets: elem,
              duration: 150,
              translateX: '-200%',
              easing: 'easeInQuad',
            })

            .add({
              targets: elem,
              duration: 10,
              opacity: 0,
              easing: 'easeInQuad',
            })

            .add({
              targets: elem,
              duration: 10,
              translateX: '200%',
              easing: 'easeInQuad',
            })
            .add({
              targets: elem,
              duration: 10,
              opacity: 1,
              easing: 'easeInQuad',
            })
            .add({
              targets: elem,
              duration: 150,
              translateX: '0%',
              easing: 'easeInQuad',
            });
        },
        animateArrowNext(element){
          var tl = anime.timeline();
          var elem = $(element).find('svg')[0];
          tl
            .add({
              targets: elem,
              duration: 200,
              translateX: '200%',
              easing: 'easeInQuad',
            })
            .add({
              targets: elem,
              duration: 10,
              opacity: 0,
              easing: 'easeInQuad',
            })
            .add({
              targets: elem,
              duration: 10,
              translateX: '-200%',
              easing: 'easeInQuad',
            })
           .add({
              targets: elem,
              duration: 10,
              opacity: 1,
              easing: 'easeInQuad',
            })
            .add({
              targets: elem,
              duration: 200,
              translateX: '000%',
              easing: 'easeInQuad',
            });
        },
        sliderHome(){
            if($('.home-carousel').get(0)){
                var $carousel = new Flickity( $('.home-carousel').get(0), {
                    autoPlay: 5500,
                    pauseAutoPlayOnHover: false,
                    draggable: false,
                    cellAlign: 'center',
                    cellSelector: '.home-carousel__item',
                    prevNextButtons: false,
                    pageDots: true,
                    percentPosition: false,
                    wrapAround: true,
                });



              var video = $('.videoreel')
              if(video.length){
                $carousel.pausePlayer()
                video.get(0).addEventListener('ended',function(){
                    $carousel.next()
                    setTimeout(() => {
                        $carousel.playPlayer()
                        $carousel.remove( $('.home-carousel__item__video').get(0) )
                    },1000)
                },false);

                $carousel.on( 'change', function( index ) {
                    // if(index !== 0){

                    // }
                    if($($('.home-carousel__item').get(index)).hasClass('home-carousel__item__video')){
                        video.get(0).currentTime = 0
                        video.get(0).play()
                    } else {
                        video.get(0).pause()
                        video.get(0).currentTime = 0
                    }
                });



              }


            }


          // if (!ieVersion && !isIE) {
          //     App.sliderParallax($carousel);
          // }



          $('.home-carousel__navigation__button--previous').on({
              mouseenter: function () {
                App.animateArrowPrev(this);
              },

              click: function() {
                $carousel.flickity('previous');
              },

          });
          $('.home-carousel__navigation__button--next').on({
              mouseenter: function () {
                App.animateArrowNext(this);
              },
              click: function() {
                $carousel.flickity('next');
              },
          });
        },
        sliderParallax(element){
          var docStyle = document.documentElement.style;
          var transformProp = typeof docStyle.transform == 'string' ?
              'transform' : 'WebkitTransform';
          var imgs = element.find('.media-figure__body');
          var flkty = element.data('flickity');
          element.on( 'scroll.flickity', function() {
            flkty.slides.forEach( function( slide, i ) {
              var img = imgs[i],
                x   = 0;
                if( 0 === i ) {
                  x = Math.abs( flkty.x ) > flkty.slidesWidth ? ( flkty.slidesWidth + flkty.x + flkty.slides[flkty.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flkty.x );
                } else if( i === flkty.slides.length - 1 ) {
                  x = Math.abs( flkty.x ) + flkty.slides[i].outerWidth < flkty.slidesWidth ? ( slide.target - flkty.slidesWidth + flkty.x - flkty.slides[i].outerWidth ) : ( slide.target + flkty.x );
                } else {
                  x = slide.target + flkty.x;
                }
              img.style[ transformProp ] = 'translateX(' + x * ( -1 / 3 ) + 'px)';
            });
          });


        },

        headerSticky(){


            if(!$('[data-point-h]').length){
              $('header.banner').addClass('stick');
              var header = $('header.banner');
              var sticky = new Waypoint.Sticky({
                element: header[0],
              });
            }


            $('[data-point-h]').waypoint(function(direction){
              $('header.banner').toggleClass('stick');
            }, {
              offset: 60,
            });

            $(window).resize(function(){
              Waypoint.refreshAll();
            });

            $('[data-scroll-down]').click(function(e){
              e.preventDefault();
              $('html, body').animate({
                scrollTop: $(this).closest('section').next('section').offset().top,
              }, 800);
            });
            $(window).scroll(function() {
                var scroll = $(window).scrollTop();
                if (scroll >= 200) {
                    $('[data-scroll-down]').addClass('hide');
                }
            });




            var triggerBttn = $( 'div.menu-mobile' ),
            menucontainer = $( 'div.mb-menu' ),
            linkBttn = $('.mb-nav a' ),
            isMenuOpen = false;

            function toggleMenu() {
              if( isMenuOpen ) {
                menucontainer.removeClass('opened');
                $('div.menu__btn_close').removeClass('menu-button--open');
                $(".hamburger").toggleClass("is-active");
                $('.bg-overlay').fadeOut(300);
                $('body').removeClass('menu-opened');
                App.removeScrollbarPad();


              }
              else {
                menucontainer.addClass('opened');
                $('div.menu__btn_close').addClass('menu-button--open');
                $(".hamburger").toggleClass("is-active");
                $('.bg-overlay').fadeIn(300);
                $('body').addClass('menu-opened');
                App.addScrollbarPad();

              }
              isMenuOpen = !isMenuOpen;
            }



           jQuery('pswp__button--close').click(function(){
            $(this).data('clicked', true);
            });



            function initEventsMenu() {
              triggerBttn.click(function(){
                toggleMenu();
              });
            }

            function init() {
              initEventsMenu();
            }
            $(document).keyup(function(e) {
                 if (e.keyCode === 27 && isMenuOpen) {
                   toggleMenu();
                }
            });


            $('.menu__btn_close').click(function(){
              toggleMenu();
            });
            $('.bg-overlay').click(function(){
              toggleMenu();
            });

            linkBttn.click(function(){
              if($(this).attr('href') !== '#'){
                toggleMenu();
                $('body').removeClass('menu-opened');
              }
            });
            $('[data-cta=magazine]').click(function(){
              if(isMenuOpen){
                toggleMenu();
              }
            });



            init();

            $('.menu-item-has-children').find('a').click(function(event){
              $(this).parent().toggleClass('opened');
              if($(this).attr('href') === '#'){
                event.preventDefault();
                $(this).next('.sub-menu').slideToggle();
              }
            });
            $('.menu-item-has-children').find('.menu-item').each(function(){
              if($(this).hasClass('active')){
                $(this).parent().parent().toggleClass('opened');
                $(this).parent('.sub-menu').show();
              }
            });
        },

        magazineForm(){

            var triggerBttn = $( '[data-cta=magazine]' ),
            menucontainer = $( '.magazine-slider' ),
            isMenuOpen = false;


            function toggleMenu() {
              if( isMenuOpen ) {
                menucontainer.removeClass('opened');
                $('.bg-overlay-forms').fadeOut(300);
                $('body').removeClass('menu-opened');

                App.removeScrollbarPad();

              }
              else {
                menucontainer.addClass('opened');
                $('.bg-overlay-forms').fadeIn(300);
                $('body').addClass('menu-opened');
                App.addScrollbarPad();
              }
              isMenuOpen = !isMenuOpen;
            }

            function initEventsMenu() {
              triggerBttn.click(function(e){
                e.preventDefault();
                toggleMenu();
              });
              var field = 'magazine';
              var url = window.location.href;
              if(url.indexOf('?' + field + '=') != -1)
                toggleMenu();
              return false


            }

            function init() {
              initEventsMenu();
            }
            menucontainer.find('.close-slide').click(function(e){
              e.preventDefault();
              toggleMenu();
            });
            $(document).keyup(function(e) {
                 if (e.keyCode === 27 && isMenuOpen) {
                   toggleMenu();
                }
            });

            $('.bg-overlay-forms').click(function(){
              if( isMenuOpen ) {
                toggleMenu();
              }
            });




            init();
        },
        listedBrochureForm(){
            var menucontainer = $( '.listed-brochure-slider' ),
            isMenuOpen = false;

            function toggleMenu() {
              if( isMenuOpen ) {
                menucontainer.removeClass('opened');
                $('.bg-overlay-forms').fadeOut(300);
                $('body').removeClass('menu-opened');
                App.removeScrollbarPad();

              }
              else {
                menucontainer.addClass('opened');
                $('.bg-overlay-forms').fadeIn(300);
                $('body').addClass('menu-opened');
                App.addScrollbarPad();
              }
              isMenuOpen = !isMenuOpen;
            }


            function initEventsMenu() {
                $(document.body).on('click', '[data-cta=listed-brochure]', function(e){
                    e.preventDefault();
                    toggleMenu();
                });

            }

            function init() {
              initEventsMenu();
            }
            $(document).keyup(function(e) {
                 if (e.keyCode === 27 && isMenuOpen) {
                   toggleMenu();
                }
            });
            menucontainer.find('.close-slide').click(function(e){
              e.preventDefault();
              toggleMenu();
            });
            $('.bg-overlay-forms').click(function(){
              if( isMenuOpen ) {
                toggleMenu();
              }
            });


            init();
        },
        brochureForm(){

            var triggerBttn = $( '[data-cta=brochure]' ),
            menucontainer = $( '.brochure-slider' ),
            isMenuOpen = false;

            function toggleMenu() {
              if( isMenuOpen ) {
                menucontainer.removeClass('opened');
                $('.bg-overlay-forms').fadeOut(300);
                $('body').removeClass('menu-opened');
                App.removeScrollbarPad();

              }
              else {
                menucontainer.addClass('opened');
                $('.bg-overlay-forms').fadeIn(300);
                $('body').addClass('menu-opened');
                App.addScrollbarPad();
              }
              isMenuOpen = !isMenuOpen;
            }


            function initEventsMenu() {
              triggerBttn.click(function(e){
                e.preventDefault();
                toggleMenu();
              });
            }

            function init() {
              initEventsMenu();
            }
            $(document).keyup(function(e) {
                 if (e.keyCode === 27 && isMenuOpen) {
                   toggleMenu();
                }
            });
            menucontainer.find('.close-slide').click(function(e){
              e.preventDefault();
              toggleMenu();
            });
            $('.bg-overlay-forms').click(function(){
              if( isMenuOpen ) {
                toggleMenu();
              }
            });


            init();
        },
        addScrollbarPad(){
                $('html').css('padding-right', getScrollbarWidth() + 'px');
                $('header.banner').css('right', getScrollbarWidth() + 'px');
                $('.ctas__footer').css('right', getScrollbarWidth() + 'px');
                $('.pswp').css('padding-right', getScrollbarWidth() + 'px');
        },
        removeScrollbarPad(){
                $('html').css('padding-right','');
                $('header.banner').css('right','');
                $('.ctas__footer').css('right','');
                $('.pswp').css('padding-right','');
        },
        enquiryForm(){

            var triggerBttn = $( '[data-cta=enquiry]' ),
            menucontainer = $( '.enquiry-slider' ),
            isMenuOpen = false;

            function toggleMenu() {
              if( isMenuOpen ) {
                menucontainer.removeClass('opened');
                $('.bg-overlay-forms').fadeOut(300);
                $('body').removeClass('menu-opened');
                App.removeScrollbarPad();

              }
              else {
                menucontainer.addClass('opened');
                $('.bg-overlay-forms').fadeIn(300);
                $('body').addClass('menu-opened');
                App.addScrollbarPad();
              }
              isMenuOpen = !isMenuOpen;
            }

            function initEventsMenu() {
              triggerBttn.click(function(e){
                e.preventDefault();
                toggleMenu();
              });
            }

            function init() {
              initEventsMenu();
            }
            $(document).keyup(function(e) {
                 if (e.keyCode === 27 && isMenuOpen) {
                   toggleMenu();
                }
            });
            menucontainer.find('.close-slide').click(function(e){
              e.preventDefault();
              toggleMenu();
            });

            $('.bg-overlay-forms').click(function(){
              if( isMenuOpen ) {
                toggleMenu();
              }
            });


            init();
        },

        reveal(){

          (function(window) {

            'use strict';

            // Helper vars and functions.
            function extend(a, b) {
              for(var key in b) {
                if( b.hasOwnProperty( key ) ) {
                  a[key] = b[key];
                }
              }
              return a;
            }

            function createDOMEl(type, className, content) {
              var el = document.createElement(type);
              el.className = className || '';
              el.innerHTML = content || '';
              return el;
            }

            /**
             * RevealFx obj.
             */
            function RevealFx(el, options) {
              this.el = el;
              this.options = extend({}, this.options);
              extend(this.options, options);
              this._init();
            }

            /**
             * RevealFx options.
             */
            RevealFx.prototype.options = {
              // If true, then the content will be hidden until it´s "revealed".
              isContentHidden: true,
              // The animation/reveal settings. This can be set initially or passed when calling the reveal method.
              revealSettings: {
                // Animation direction: left right (lr) || right left (rl) || top bottom (tb) || bottom top (bt).
                direction: 'lr',
                // Revealer´s background color.
                bgcolor: '#f0f0f0',
                // Animation speed. This is the speed to "cover" and also "uncover" the element (seperately, not the total time).
                duration: 500,
                // Animation easing. This is the easing to "cover" and also "uncover" the element.
                easing: 'easeInOutQuint',
                // percentage-based value representing how much of the area should be left covered.
                coverArea: 0,
                // Callback for when the revealer is covering the element (halfway through of the whole animation).
                onCover: function(contentEl, revealerEl) { return false; },
                // Callback for when the animation starts (animation start).
                onStart: function(contentEl, revealerEl) { return false; },
                // Callback for when the revealer has completed uncovering (animation end).
                onComplete: function(contentEl, revealerEl) { return false; },
              },
            };

            /**
             * Init.
             */
            RevealFx.prototype._init = function() {
              this._layout();
            };

            /**
             * Build the necessary structure.
             */
            RevealFx.prototype._layout = function() {
              var position = getComputedStyle(this.el).position;
              if( position !== 'fixed' && position !== 'absolute' && position !== 'relative' ) {
                this.el.style.position = 'relative';
              }
              // Content element.
              this.content = createDOMEl('div', 'block-revealer__content', this.el.innerHTML);
              if( this.options.isContentHidden) {
                this.content.style.opacity = 0;
              }
              // Revealer element (the one that animates)
              this.revealer = createDOMEl('div', 'block-revealer__element');
              this.el.classList.add('block-revealer');
              this.el.innerHTML = '';
              this.el.appendChild(this.content);
              this.el.appendChild(this.revealer);
            };

            /**
             * Gets the revealer element´s transform and transform origin.
             */
            RevealFx.prototype._getTransformSettings = function(direction) {
              var val, origin, origin_2;

              switch (direction) {
                case 'lr' :
                  val = 'scale3d(0,1,1)';
                  origin = '0 50%';
                  origin_2 = '100% 50%';
                  break;
                case 'rl' :
                  val = 'scale3d(0,1,1)';
                  origin = '100% 50%';
                  origin_2 = '0 50%';
                  break;
                case 'tb' :
                  val = 'scale3d(1,0,1)';
                  origin = '50% 0';
                  origin_2 = '50% 100%';
                  break;
                case 'bt' :
                  val = 'scale3d(1,0,1)';
                  origin = '50% 100%';
                  origin_2 = '50% 0';
                  break;
                default :
                  val = 'scale3d(0,1,1)';
                  origin = '0 50%';
                  origin_2 = '100% 50%';
                  break;
              }

              return {
                // transform value.
                val: val,
                // initial and halfway/final transform origin.
                origin: {initial: origin, halfway: origin_2},
              };
            };

            /**
             * Reveal animation. If revealSettings is passed, then it will overwrite the options.revealSettings.
             */
            RevealFx.prototype.reveal = function(revealSettings) {
              // Do nothing if currently animating.
              if( this.isAnimating ) {
                return false;
              }
              this.isAnimating = true;

              // Set the revealer element´s transform and transform origin.
              var defaults = { // In case revealSettings is incomplete, its properties deafault to:
                  duration: 500,
                  easing: 'easeInOutQuint',
                  delay: 0,
                  bgcolor: '#f0f0f0',
                  direction: 'lr',
                  coverArea: 0,
                },
                revealSettings = revealSettings || this.options.revealSettings,
                direction = revealSettings.direction || defaults.direction,
                transformSettings = this._getTransformSettings(direction);

              this.revealer.style.WebkitTransform = this.revealer.style.transform =  transformSettings.val;
              this.revealer.style.WebkitTransformOrigin = this.revealer.style.transformOrigin =  transformSettings.origin.initial;

              // Set the Revealer´s background color.
              this.revealer.style.backgroundColor = revealSettings.bgcolor || defaults.bgcolor;

              // Show it. By default the revealer element has opacity = 0 (CSS).
              this.revealer.style.opacity = 1;

              // Animate it.
              var self = this,
                // Second animation step.
                animationSettings_2 = {
                  complete: function() {
                    self.isAnimating = false;
                    if( typeof revealSettings.onComplete === 'function' ) {
                      revealSettings.onComplete(self.content, self.revealer);
                    }
                  },
                },
                // First animation step.
                animationSettings = {
                  delay: revealSettings.delay || defaults.delay,
                  complete: function() {
                    self.revealer.style.WebkitTransformOrigin = self.revealer.style.transformOrigin = transformSettings.origin.halfway;
                    if( typeof revealSettings.onCover === 'function' ) {
                      revealSettings.onCover(self.content, self.revealer);
                    }
                    anime(animationSettings_2);
                  },
                };

              animationSettings.targets = animationSettings_2.targets = this.revealer;
              animationSettings.duration = animationSettings_2.duration = revealSettings.duration || defaults.duration;
              animationSettings.easing = animationSettings_2.easing = revealSettings.easing || defaults.easing;

              var coverArea = revealSettings.coverArea || defaults.coverArea;
              if( direction === 'lr' || direction === 'rl' ) {
                animationSettings.scaleX = [0,1];
                animationSettings_2.scaleX = [1,coverArea/100];
              }
              else {
                animationSettings.scaleY = [0,1];
                animationSettings_2.scaleY = [1,coverArea/100];
              }

              if( typeof revealSettings.onStart === 'function' ) {
                revealSettings.onStart(self.content, self.revealer);
              }
              anime(animationSettings);
            };

            window.RevealFx = RevealFx;

          })(window);



          // RIGHT
          var $fadedelementsright = $('.datascroll-right');
          $fadedelementsright.each(function(){
            var $e = this;
            var elementWatcher = scrollMonitor.create($e);
            var delayS = $($e).attr('data-delay');
            var el = new RevealFx($e);
            var colorbg;
            if($($e).attr('data-color')){
              colorbg = $($e).attr('data-color');
            } else{
              colorbg = '#f0f0f0';
            }

            elementWatcher.enterViewport(function() {
              el.reveal({
                bgcolor: colorbg,
                duration: 800,
                delay: delayS,
                direction: 'rl',
                onStart: function(contentEl, revealerEl) { contentEl.style.opacity = 0; App.lazyLoad(); },
                onCover: function(contentEl, revealerEl) { contentEl.style.opacity = 1; },
                onComplete: function(contentEl, revealerEl) { elementWatcher.destroy();  },
              });
            });
          });







          // LEFT
          var $fadedelementsleft = $('.datascroll-left');
          $fadedelementsleft.each(function(){
            var $left = this;
            var elementWatcherleft = scrollMonitor.create($left);
            var delaySleft = $($left).attr('data-delay');
            var elLeft = new RevealFx($left);
            var colorbgLeft;
            if($($left).attr('data-color')){
              colorbgLeft = $($left).attr('data-color');
            } else{
              colorbgLeft = '#f0f0f0';
            }

            elementWatcherleft.enterViewport(function() {
              elLeft.reveal({
                bgcolor: colorbgLeft,
                duration: 800,
                delay: delaySleft,
                onStart: function(contentEl, revealerEl) { contentEl.style.opacity = 0; App.lazyLoad(); },
                onCover: function(contentEl, revealerEl) { contentEl.style.opacity = 1; },
                onComplete: function(contentEl, revealerEl) { elementWatcherleft.destroy();  },
              });
            });
          });


          // ANIMATION LOGO
          var $fadedelementslogo = $('#lineDrawing');
          $fadedelementslogo.each(function(){
            var $e = $(this);
            var elementWatcher = scrollMonitor.create($e);
            elementWatcher.enterViewport(function() {
                anime({
                  targets: '#lineDrawing .lines path',
                  strokeDashoffset: [anime.setDashoffset, 0],
                  easing: 'easeInOutSine',
                  duration: 5000,
                  delay: function(el, i) { return i * 250 },
                  direction: 'alternate',
                  loop: false,
                });
            });
          });

          // FADE
          var $fadedelementsfade = $('.datascroll-fade');
          $fadedelementsfade.each(function(){
            var $e = $(this);
            var elementWatcher = scrollMonitor.create($e);
            elementWatcher.enterViewport(function() {
              setTimeout(function(){
                $e.addClass('loaded-fade');
              },200);
            });
          });

        },
        equalBlogTitles(){

          $('.grid__post').each(function(){
            var highestBox = 0;
            $('.entry-title', this).each(function(){
              if($(this).height() > highestBox) {
                highestBox = $(this).height();
              }
            });
            $('.entry-title',this).height(highestBox);
          });



        },

        photoswipeInit() {

          $('body').on('click', '[data-size]', function(e) {
            if( !PhotoSwipe || !PhotoSwipeUI_Default ) {
              return;
            }
            e.preventDefault();
            openPhotoSwipe( this );
          });

          $('body').on('click', '.parselector', function(e) {
            if( !PhotoSwipe || !PhotoSwipeUI_Default ) {
              return;
            }
            e.preventDefault();
            openPhotoSwipe( this );
          });

          var parseThumbnailElements = function(gallery, el) {
            var elements = $(gallery).find('[data-size], .parselector').has('[data-pswp]'),
              galleryItems = [],
              index;


            elements.each(function(i) {
              var $el = $(this),
                size,
                caption;

              if($el.is('a')){
                size = $el.data('size').split('x');
              } else {
                size = [$el.find('[data-pswp]').attr('data-natural-width'), $el.find('[data-pswp]').attr('data-natural-height')];
              }



              if($el.is('a')){
                if( $el.next().is('.wp-caption-text') ) {
                  // image with caption
                  caption = $el.next().text();
                } else if( $el.parent().next().is('.wp-caption-text') ) {
                  // gallery icon with caption
                  caption = $el.parent().next().text();
                } else {
                  caption = $el.attr('title');
                }
                galleryItems.push({
                  src: $el.attr('href'),
                  w: parseInt(size[0], 10),
                  h: parseInt(size[1], 10),
                  title: caption,
                  msrc: $el.find('[data-pswp]').attr('src'),
                  el: $el,
                });
              } else {


                if( $el.find('.wp-caption-text') ) {
                  caption = $el.find('.wp-caption-text').text();
                }



                galleryItems.push({
                  src: $el.find('[data-pswp]').attr('data-image-src'),
                  w: parseInt(size[0], 10),
                  h: parseInt(size[1], 10),
                  title: caption,
                  msrc: $el.find('[data-pswp]').attr('data-image-src'),
                  el: $el,
                });
              }

              if( el === $el.get(0) ) {
                index = i;
              }
            });

            return [galleryItems, parseInt(index, 10)];
          };

          var openPhotoSwipe = function( element, disableAnimation ) {
            var pswpElement = $('.pswp').get(0),
              galleryElement = $(element).parents('.gallery, .hentry, .main, body').first(),
              gallery,
              options,
              items, index;

            items = parseThumbnailElements(galleryElement, element);
            index = items[1];
            items = items[0];

            options = {
              index: index,
              closeOnScroll: true,
              getThumbBoundsFn: function(index) {
                var image = items[index].el.find('[data-pswp]'),
                  offset = image.offset();

                return {x:offset.left, y:offset.top, w:image.width()};
              },
              showHideOpacity: true,
              history: false,
            };

            if(disableAnimation) {
              options.showAnimationDuration = 0;
            }

            gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init();

            $('body').removeClass('menu-opened');

            // $('.pswp__button--close').click(
            // function(e) {
            //     e.preventDefault(); // prevent the default action
            //     e.stopPropagation(); // stop the click from bubbling
            //     // $(this).closest('ul').find('.selected').removeClass('selected');
            //     $('body').removeClass('menu-opened');
            // });


            gallery.listen('close', function() {
            $('body').removeClass('menu-opened');

            });

          };

          $('body').on('click', '.pswp .title', function() {
            $('.pswp__button--close').click();
          });

          // $('.pswp__button--close').on('click', function() {
          //   $('body').removeClass('menu-opened');
          // });

        },
        getUrlVars(){
            var queries = {};
              $.each(document.location.search.substr(1).split('&'),function(c,q){
                var i = q.split('=');
                queries[i[0].toString()] = i[1].toString();
              });
              return queries
        },
        caseStudies(){
          var app = this
          // var queryload = this.getUrlVars()
          // console.log(queryload)
          var url = window.location.href.split('?')[0]
          $('.filter-btn').on("click touchend", function(e) {
            e.preventDefault();
            $('.grid-cases').addClass('filtered');

            var classSelected = $(this).attr('data-filter');
            if (classSelected === 'all') {
              $('.block-filter').addClass('active');
                window.history.pushState(null, null, url);
            } else {
                window.history.pushState(null, null, url + '?filter=' + classSelected);
              var $el = $('.' + classSelected).addClass('active');
              $('.block-filter').not($el).removeClass('active');
            }
            $('.filter-btn').removeClass('active');
            $(this).addClass('active');
            $('html, body').animate({ scrollTop: 0 });
            window.dispatchEvent(new Event('resize'));

          });

        },
        socialSharer() {

          $('.social-share').click(function(e){
            e.preventDefault();
            window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=420,width=420');
          });

        },

    };
    App.socialSharer();
    App.equalBlogTitles();
    App.countupLoad();
    App.animeLoad();
    App.lazyLoad();
    App.sliderHome();
    App.headerSticky();
    App.slidersPages();
    App.photoswipeInit();
    App.caseStudies();
    App.stickyCTA();
    App.postcodeLookup();
    App.magazineForm();
    App.brochureForm();
    App.listedBrochureForm();
    App.enquiryForm();
  },


  finalize() {
        document.addEventListener( 'wpcf7mailsent', function( event ) {
              var inputs = event.detail.inputs;
              var email = '?your-email=';
              for ( var i = 0; i < inputs.length; i++ ) {
                  if ( 'your-email' == inputs[i].name ) {
                      email = email + inputs[i].value;
                      break;
                  }
              }


              if(event.detail.contactFormId === 1529){
                window.location.href = '/enquiry-thanks' + email;
              } else if(event.detail.contactFormId === 253) {
                window.location.href = '/brochure-thanks-post' + email;
              } else if(event.detail.contactFormId === 2692){
                window.location.href = '/enquiry-slide-thanks' + email;
              } else if(event.detail.contactFormId === 1528){
                window.location.href = '/magazine' + email;
              } else if(event.detail.contactFormId === 1530 || event.detail.contactFormId === 2726) {
                window.location.href = '/brochure-thanks-download' + email;
              } else if(event.detail.contactFormId === 96022 ) {
                window.location.href = '/listed-brochure-thanks-download' + email;
              } else if(event.detail.contactFormId === 96028 ) {
                window.location.href = '/listed-brochure-thanks-post' + email;
              }

        }, false );
      ( function () {
        if ( typeof window.CustomEvent === "function" ) return false;

        function CustomEvent ( event, params ) {
          params = params || { bubbles: false, cancelable: false, detail: undefined };
          var evt = document.createEvent( 'CustomEvent' );
          evt.initCustomEvent( event,
            params.bubbles, params.cancelable, params.detail );
          return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
      } )();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js